var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('SiteMasthead'),_c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("Not Found")]),_c('h5',[_vm._v("The requested page could not be found.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }